import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

type WarningDismissalContextType = {
  isDismissed: (nodeId: string) => boolean;
  dismissWarning: (nodeId: string) => void;
};

const WarningDismissalContext = createContext<WarningDismissalContextType>({
  isDismissed: () => false,
  dismissWarning: () => {},
});

export const useWarningDismissal = () => useContext(WarningDismissalContext);

export const WarningDismissalProvider = ({ children }: { children: ReactNode }) => {
  const [dismissedWarnings, setDismissedWarnings] = useState<Set<string>>(new Set());

  const isDismissed = useCallback((nodeId: string) => dismissedWarnings.has(nodeId), [dismissedWarnings]);

  const dismissWarning = useCallback((nodeId: string) => {
    setDismissedWarnings((prev) => new Set(prev).add(nodeId));
  }, []);

  return (
    <WarningDismissalContext.Provider value={{ isDismissed, dismissWarning }}>
      {children}
    </WarningDismissalContext.Provider>
  );
};
